<template>
  <modal
    :header-text="headerText"
    :button-text="btnText"
    :width="widthWindow"
    :not-backdrop="true"
    @action="addData()"
    @close="close()"
  >
    <div
      v-if="isDelete"
      :class="$style.container"
    >
      {{ $t('settings.deleteRequest') }}
    </div>
    <search
      v-else
      ref="searchRef"
      :is-setting-mode="true"
      :edit-query="item"
      @updateQuery="updateQuery"
    />
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/settings-modal.vue';
  import Search from '@/views/search/search.vue';

  export default {
    components: {
      Modal,
      Search,
    },
    props: ['data', 'item', 'isDelete'],
    data() {
      return {
        queryText: '',
        queryJson: '',
        comment: '',
        itemId: null,
      };
    },
    computed: {
      headerText() {
        if (this.isDelete) return this.$t('global.confirm');
        return this.item ? this.$t('settings.editRequest') : this.$t('settings.addRequest');
      },
      widthWindow() {
        if (this.isDelete) return 20;
        return 60;
      },
      btnText() {
        return this.isDelete ? this.$t('global.delete') : this.$t('global.save');
      },
      profileId() {
        return this.$store.getters['settings/profile'];
      },
      isValidData() {
        return !this.queryText || !this.queryJson || !this.comment;
      },
    },

    methods: {
      close() {
        this.$emit('close');
      },
      updateQuery(query, json, comment, itemId) {
        this.queryText = query;
        this.queryJson = json;
        this.comment = comment;
        this.itemId = itemId;
      },
      async addData() {
        if (!this.isDelete && this.isValidData) {
          this.$refs.searchRef.search();
          if (this.isValidData) return;
        }

        let items;

        const itemId = this.item?.id;
        const isNewItem = typeof itemId === 'string' && itemId.startsWith('item');

        const currentItem = {
          id: this.item?.id || this.itemId || `item_${this.data.length}`,
          profileId: this.profileId,
          queryText: this.queryText,
          queryJson: this.queryJson,
          comment: this.comment,
        };

        if (this.isDelete && this.item) {
          items = this.data.filter((item) => item.id !== itemId);

          if (isNewItem) {
            this.$store.commit('settings/removeAddCompoundRulesSettings', itemId);
          } else {
            this.$store.commit('settings/delCompoundRulesSettings', itemId);
          }
        } else if (!this.isDelete && this.item) {
          items = this.data.map((item) => (item.id === itemId ? currentItem : item));

          if (isNewItem) {
            this.$store.commit('settings/updateCompoundRulesSettings', currentItem);
          } else {
            this.$store.commit('settings/editCompoundRulesSettings', currentItem);
          }
        } else {
          items = [...this.data, currentItem];

          this.$store.commit('settings/addCompoundRulesSettings', currentItem);
        }

        this.$emit('update', items);
      },
    },
  };
</script>

<style lang="scss" module>
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .containerBody {
    padding: 10px;
  }
  .inputContainer {
    display: grid;
    grid-template-columns: 180px 1fr;
    align-items: center;
    gap: 10px;
  }

  .input,
  .textarea,
  .inputWrapper {
    width: 100%;
  }
  .textarea,
  .input {
    margin: 5px;
    width: 100%;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
  }
  .inputScreen {
    width: 60px;
  }
  .textarea {
    height: 60px;
    resize: vertical;
  }
  .inputDisabled {
    opacity: 0.2;
  }

  .inputWrapper {
    display: flex;
    gap: 2px;
    align-items: center;
  }

  .button {
    margin: 5px;
    height: 30px;
    cursor: pointer;
    width: 150px;
    background: #2985bf;
    border: 2px solid #2985bf;
    border-radius: 2px;
    font: inherit;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }

  .universalContainer {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .mainFilesContainer {
    display: flex;
    margin: 10px;
    border: 1px solid #c4c4c4;
    padding: 10px;
    align-items: center;
  }

  .md5Input {
    height: 30px;
    width: 30%;
    margin: 10px;
    min-width: 110px;
  }

  .dateFiles {
    min-width: 270px;
    margin: 0px 20px;
  }

  .dateFilesContainer {
    display: flex;
    align-items: baseline;
  }

  .dateFilesPicker {
    margin: 5px;
  }

  .dateContainer {
    display: flex;
    align-items: baseline;

    @media (max-width: 1840px) {
      flex-direction: column;
    }
  }

  .datePicker {
    margin: 5px;

    @media (max-width: 1840px) {
      width: 80%;
    }
  }

  .dateLabel {
    margin-right: 5px;
    font-size: 14px;
    width: 5%;
  }

  .buttonContainer {
    margin: 10px;
    display: flex;
    justify-content: center;
  }
</style>

<style>
  .searchTabs {
    padding: 0px !important;
  }

  .drag-tree-table {
    margin: 0;
    color: black;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }

  .drag-tree-table-header {
    background: #f5f5f5;
    line-height: 20px;
  }

  .tree-row {
    line-height: 20px;
  }

  .searchLogs {
    display: flex;
    flex-direction: column;
    margin: 5px 0px;
  }

  .searchLogs .vue-treeselect {
    margin-left: 2%;
  }

  .searchLogs .vue-treeselect__control {
    border-radius: 0px;
    width: 95%;
  }

  .searchLogs .vue-treeselect__menu {
    width: 95%;
    max-height: 160px;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .searchLogs .vue-treeselect__option {
    font-size: 14px;
  }

  .searchLogs .vue-treeselect__multi-value {
    margin: 3px 0px;
  }

  .searchLogs .vue-treeselect__multi-value-item-container {
    padding-top: 3px;
  }

  .searchLogs .iconFolder {
    display: inline-flex;
  }

  .searchLogs .vue-treeselect__checkbox--checked {
    background-color: #2985bf;
    border: 1px solid #2985bf;
  }

  .searchLogs .vue-treeselect__check-mark {
    margin: 0.5px;
  }

  input[type='file'] {
    display: none;
  }

  .custom-file-upload {
    border: 1px solid white;
    cursor: pointer;
    color: white;
    height: 36px;
    background: #2985bf;
    padding: 9px 12px;
    display: inline-block;
    margin: 5px;
    font-size: 14px;
    min-width: 226px;
  }
</style>
